import { machineLabel } from "./machineLabel";

/**
 * How an exercise is named on screen once EQ-1-HIST can produce more than one
 * row for it in the same session — one per physical machine.
 *
 * ⭐ Exists because the composition was about to be written a second time.
 * `AlertsPanel` needed it first (a regression alert has to say WHICH machine is
 * declining, or it reads as a decline on the exercise itself); the post-session
 * summary needs the identical thing the moment an athlete logs one exercise on
 * two machines in one session, and without it the two rows render with the same
 * name and the same React key. Two callsites, one rule.
 *
 * ⛔ The separator is the same middot the rest of the app uses for a qualified
 * name; do not "improve" it in one place only.
 *
 * An untagged exercise — which is every exercise logged before EQ-1-HIST, and
 * all of production today — gets its plain name back, byte for byte. The label
 * only grows when the athlete actually named a machine.
 */
export function exerciseTrackLabel(
  exerciseName: string,
  equipmentInstance: string | undefined,
  t: (k: string, opts?: Record<string, unknown>) => string,
): string {
  if (!equipmentInstance) return exerciseName;
  return `${exerciseName} · ${machineLabel(equipmentInstance, t)}`;
}
